module.exports = "<div class=\"sidebar\">\n\n</div>\n"